﻿import State from './State.js';
export default class StateEndRound extends State {
    constructor(context) {
        super(context);
        this.name = 'endRound';
    }
    setup() {
        this.context.playerTurn = null;
        if (this.context.player1) this.context.player1.ready = false;
        if (this.context.player2) this.context.player2.ready = false;
    }
    action(command, value, player) {
        switch (command) {
            case "nextRound": return this.nextRound(player); break;
            case "next": return this.nextRound(player); break;
            default: this.unknownCommand(command, value, player);
        }
    }
    getActions(player) {
        let actions = [];
        let player1 = this.context.player1;
        let player2 = this.context.player2;

        //check if already ready-ed up
        if (player === "player1" && player1.ready) return [];
        if (player === "player2" && player2.ready) return [];

        actions.push({ command: "nextRound", value: null, player: player });
        actions.push({ command: "next", value: null, player: player });
        return actions;
    }
    nextRound(player) {
        let bothReady = false;

        let player1 = this.context.player1;
        let player2 = this.context.player2;

        if (player1 && player === "player1") {
            player1.ready = true;
        }
        if (player2 && player === "player2") {
            player2.ready = true;
        }
        if ((player1 && player1.ready) && (player2 && player2.ready)) {
            bothReady = true;
        }

        if (bothReady) {
            const isMatchOver = this.context.checkForEndOfMatch()
            if (isMatchOver) {
                this.endMatch();
            } else {
                this.start();
            }
        }

        //set turn
        if (player === "player1") {
            this.context.playerTurn = "player2";
        } else {
            this.context.playerTurn = "player1";
        }
        return true;
    }
    start() {
        this.context.setState("startRound");
    }
    endMatch() {
        this.context.matchEnd();
    }
    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}